/** =========================================================
 * Module: items-pagination.directive.js
 * Data items pagination
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.components')
    .directive('itemsPagination', itemsPagination);

  itemsPagination.$inject = ['MainPreloader'];

  function itemsPagination(MainPreloader) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/components/items-pagination.html',
      link: link,
      scope: {
        config: '='
      }
    };

    return directive;

    function link($scope) {
      if ($scope.config && $scope.config.model && $scope.config.getData && $scope.config.getDataParams) {
        $scope.paginate = function (page) {
          try {
            MainPreloader.show();

            $scope.config.getDataParams.page = page;

            $scope.config.getData().then(MainPreloader.hide, MainPreloader.hide);
          } catch (error) {
            MainPreloader.hide();

            Raven.captureException(error);
          }
        };

        $scope.goTo = function (pageValue) {
          if (pageValue < 1 || pageValue > $scope.config.pages) {
            $scope.pageValue = undefined;
          } else {
            $scope.pageValue = pageValue;
            $scope.paginate($scope.pageValue);
          }
        };
      }
    }
  }
})();
